import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";

// Keep Home eager if you want fastest first paint on "/"
import Home from "./pages/Home";

// Lazy pages (loaded only when route matches)
const Terms = lazy(() => import("./pages/Terms"));
const Privacy = lazy(() => import("./pages/Privacy"));
const News = lazy(() => import("./pages/News"));
const ChooseSport = lazy(() => import("./pages/ChooseSport"));
const ChooseCompetition = lazy(() => import("./pages/ChooseCompetition"));
const ModeSelect = lazy(() => import("./pages/ModeSelect"));
const Signup = lazy(() => import("./pages/Signup"));
const Signin = lazy(() => import("./pages/Signin"));
const Avatar = lazy(() => import("./pages/Avatar"));
const Sports = lazy(() => import("./pages/Sports"));
const SelectionReview = lazy(() => import("./pages/SelectionReview"));
const Games = lazy(() => import("./pages/Games"));
const Leagues = lazy(() => import("./pages/Leagues"));
const Calendar = lazy(() => import("./pages/Calendar"));
const Predictor = lazy(() => import("./pages/Predictor"));
const League = lazy(() => import("./pages/League"));
const Notifications = lazy(() => import("./pages/Notifications"));
const FourInARow = lazy(() => import("./pages/4InARow"));
const FourInARowMultiplayer = lazy(() => import("./pages/4InARowMultiplayer"));
const PlayRedirect = lazy(() => import("./pages/PlayRedirect"));
const MatchdayChampion = lazy(() => import("./pages/MatchdayChampion"));
const MatchdayChampionTerms = lazy(() => import("./pages/MatchdayChampionTerms"));
const MatchdayChampionPrivacy = lazy(() => import("./pages/MatchdayChampionPrivacy"));
const MatchdayChampionLeaderboard = lazy(() => import("./pages/MatchdayChampionLeaderboard"));
const MatchdayChampionFAQs = lazy(() => import("./pages/MatchdayChampionFAQs"));
const PatchworkPlanetPrivacy = lazy(() => import("./pages/PatchworkPlanetPrivacy"));
const PatchworkPlanetTerms = lazy(() => import("./pages/PatchworkPlanetTerms"));
const PatchworkPlanetFAQs = lazy(() => import("./pages/PatchworkPlanetFAQs"));

function AppLayoutRoute() {
  return <AppLayout><Outlet /></AppLayout>;
}

export default function App() {
  return (
    <Suspense fallback={<div style={{ padding: 24, color: "white" }}>Loading…</div>}>
      <Routes>

        {/* Standalone — no AppLayout, no header, no constraints */}
        <Route path="/MatchdayChampion" element={<MatchdayChampion />} />
        <Route path="/MatchdayChampion/Terms" element={<MatchdayChampionTerms />} />
        <Route path="/MatchdayChampion/Privacy" element={<MatchdayChampionPrivacy />} />
        <Route path="/MatchdayChampion/Leaderboard" element={<MatchdayChampionLeaderboard />} />
        <Route path="/MatchdayChampion/FAQs" element={<MatchdayChampionFAQs />} />
        <Route path="/PatchworkPlanet/Privacy" element={<PatchworkPlanetPrivacy />} />
        <Route path="/PatchworkPlanet/Terms" element={<PatchworkPlanetTerms />} />
        <Route path="/PatchworkPlanet/FAQs" element={<PatchworkPlanetFAQs />} />

        {/* All other routes wrapped in AppLayout */}
        <Route element={<AppLayoutRoute />}>
          <Route path="/" element={<Home />} />
          <Route path="/4InARow" element={<FourInARow />} />
          <Route path="/Games/multiplayer" element={<FourInARowMultiplayer />} />
          <Route path="/play/:matchId" element={<PlayRedirect />} />
          <Route path="/Games/Choose-Sport" element={<ChooseSport />} />
          <Route path="/Games/Choose-Competition/:sportKey" element={<ChooseCompetition />} />
          <Route path="/Games/mode" element={<ModeSelect />} />
          <Route path="/Signup" element={<Signup />} />
          <Route path="/Signin" element={<Signin />} />
          <Route path="/Avatar" element={<Avatar />} />
          <Route path="/Sports" element={<Sports />} />
          <Route path="/SelectionReview" element={<SelectionReview />} />
          <Route path="/Games" element={<ProtectedRoute><Games /></ProtectedRoute>} />
          <Route path="/Leagues" element={<ProtectedRoute><Leagues /></ProtectedRoute>} />
          <Route path="/Calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
          <Route path="/Predictor" element={<ProtectedRoute><Predictor /></ProtectedRoute>} />
          <Route path="/League" element={<League />} />
          <Route path="/league/:sportKey" element={<League />} />
          <Route path="/News/:label/:id" element={<News />} />
          <Route path="/Notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
          <Route path="/Terms" element={<Terms />} />
          <Route path="/Privacy" element={<Privacy />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>

      </Routes>
    </Suspense>
  );
}
